import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Download, Globe } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const PURCHASE_URL = 'https://tucambiohoy.online/cart/42988674941041:1';
export function PricingSection() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const basePrice = 14.99;
  const totalPrice = basePrice + (bump1 ? 7 : 0) + (bump2 ? 9 : 0);
  const getPurchaseUrl = () => {
    if (bump1 && bump2) return 'https://tucambiohoy.online/cart/43043741663345:1';
    if (bump1) return 'https://tucambiohoy.online/cart/43043794419825:1';
    if (bump2) return 'https://tucambiohoy.online/cart/43043752706161:1';
    return 'https://tucambiohoy.online/cart/42988674941041:1';
  };
  const handleBuy = () => {
    trackAddToCart();
    window.open(getPurchaseUrl(), '_blank');
  };
  return <Section id="pricing" background="white" data-id="element-168">
      <div className="max-w-md mx-auto" data-id="element-169">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-2 border-[#dc4a3d]" data-id="element-170">
          <div className="bg-gradient-to-r from-[#dc4a3d] to-[#c0392b] p-4 text-center" data-id="element-171">
            <p className="text-white/90 text-xs font-bold uppercase tracking-widest mb-1" data-id="element-172">
              🔥 Oferta Especial de Lanzamiento
            </p>
            <h2 className="text-xl font-extrabold text-white" data-id="element-173">
              Pack Completo "Pantallas Bajo Control"
            </h2>
          </div>

          <div className="p-6 text-center" data-id="element-174">
            <p className="text-gray-500 text-sm mb-3" data-id="element-175">
              Valor total del pack + 3 bonos:
            </p>
            <p className="text-2xl text-gray-400 line-through mb-1 font-bold" data-id="element-176">
              $83.00 USD
            </p>
            <p className="text-gray-500 text-sm mb-2" data-id="element-177">
              Hoy lo obtienes por solo:
            </p>
            <div className="flex items-center justify-center mb-3" data-id="element-178">
              <span className="text-5xl font-extrabold text-[#dc4a3d]" data-id="element-179">
                ${totalPrice.toFixed(2)}
              </span>
              <span className="text-gray-400 ml-2 text-lg" data-id="element-180">USD</span>
            </div>
            <p className="text-green-600 font-bold text-base md:text-lg mb-4 animate-pulse" data-id="element-181">
              Ahorras $68 USD
            </p>

            <Button fullWidth size="lg" onClick={handleBuy} className="mb-4 shadow-xl shadow-red-200 text-base" data-id="element-182">
              ¡SÍ, QUIERO EL PACK COMPLETO!
            </Button>

            <div className="flex items-center justify-center gap-4 mb-5 flex-wrap" data-id="element-183">
              <div className="flex items-center gap-1 text-gray-500 text-xs" data-id="element-184">
                <Download className="w-3.5 h-3.5" data-id="element-185" />
                <span data-id="element-186">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1 text-gray-500 text-xs" data-id="element-187">
                <Globe className="w-3.5 h-3.5" data-id="element-188" />
                <span data-id="element-189">Cualquier país</span>
              </div>
              <div className="flex items-center gap-1 text-gray-500 text-xs" data-id="element-190">
                <ShieldCheck className="w-3.5 h-3.5" data-id="element-191" />
                <span data-id="element-192">Pago seguro</span>
              </div>
            </div>

            <div className="flex items-center justify-center gap-3 flex-wrap pt-4 border-t border-gray-100" data-id="element-193">
              <div className="bg-gray-100 px-3 py-1.5 rounded text-xs font-bold text-gray-600" data-id="element-194">
                VISA
              </div>
              <div className="bg-gray-100 px-3 py-1.5 rounded text-xs font-bold text-gray-600" data-id="element-195">
                MASTERCARD
              </div>
              <div className="bg-blue-100 px-3 py-1.5 rounded text-xs font-bold text-blue-700" data-id="element-196">
                PayPal
              </div>
              <div className="bg-green-100 px-3 py-1.5 rounded text-xs font-bold text-green-700" data-id="element-197">
                🔒 SSL Seguro
              </div>
            </div>
          </div>
        </div>

        {/* Order Bump #1 - Botón de Paz */}
        <div className={`mt-5 rounded-xl border-2 border-dashed transition-colors ${bump1 ? 'border-green-500 bg-green-50/50' : 'border-green-400 bg-white'} overflow-hidden shadow-md`} data-id="element-198">
          <div className="bg-green-500 px-4 py-2 flex items-center justify-center gap-2" data-id="element-199">
            <span className="text-lg" data-id="element-200">⚡</span>
            <span className="text-white text-xs font-bold uppercase tracking-wide" data-id="element-201">
              Oferta especial — Solo con tu compra
            </span>
          </div>
          <div className="p-4" data-id="element-202">
            <div className="flex gap-4 items-start mb-3" data-id="element-203">
              <img src="https://cdn.magicpatterns.com/uploads/u1LHSgA66XsC3sG6xjXYTY/Order_Bump_1_Boton_de_Paz.png" alt="Botón de Paz" className="w-24 md:w-28 rounded-lg shadow-sm shrink-0 object-cover" data-id="element-204" />
              <h4 className="font-bold text-[#1e3a5f] text-sm md:text-base leading-snug" data-id="element-205">
                ¿Quieres detener los berrinches hoy mismo? (Acceso Instantáneo
                por solo <span className="text-red-600" data-id="element-206">$7.00</span>)
              </h4>
            </div>
            <p className="text-[#2d3748] text-xs md:text-sm leading-relaxed mb-3" data-id="element-207">
              Evita los gritos y la rebeldía al apagar las pantallas. Con el{' '}
              <strong data-id="element-208">"BOTÓN DE PAZ"</strong>, tendrás los scripts de frases
              exactas y las técnicas de transición rápida para que tus hijos (de
              2 a 17 años) entreguen sus dispositivos con calma y respeto. No te
              arriesgues a una pelea esta noche; domina el arte de la
              desconexión sin conflictos.
            </p>
            <label className="flex items-start gap-3 cursor-pointer group p-3 rounded-lg border border-green-200 bg-green-50 hover:bg-green-100 transition-colors" onClick={() => setBump1(!bump1)} data-id="element-209">
              <div className={`w-5 h-5 rounded border-2 flex items-center justify-center shrink-0 mt-0.5 transition-colors ${bump1 ? 'bg-green-500 border-green-500' : 'border-gray-300 bg-white'}`} data-id="element-210">
                {bump1 && <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-211">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-212" />
                  </svg>}
              </div>
              <span className="text-xs md:text-sm text-[#1e3a5f] font-semibold leading-snug" data-id="element-213">
                Sí, añadir el Botón de Paz a mi pedido por solo{' '}
                <span className="text-red-600" data-id="element-214">$7.00 USD</span>{' '}
                <span className="text-green-600" data-id="element-215">(Ahorra un 60%)</span>
              </span>
            </label>
            <p className="text-[10px] text-gray-400 mt-2 text-center italic" data-id="element-216">
              Utilizado por más de 500 familias esta semana
            </p>
          </div>
        </div>

        {/* Order Bump #2 - Dopamina Real */}
        <div className={`mt-4 rounded-xl border-2 border-dashed transition-colors ${bump2 ? 'border-blue-500 bg-blue-50/50' : 'border-blue-400 bg-white'} overflow-hidden shadow-md`} data-id="element-217">
          <div className="bg-blue-600 px-4 py-2 flex items-center justify-center gap-2" data-id="element-218">
            <span className="text-lg" data-id="element-219">⚡</span>
            <span className="text-white text-xs font-bold uppercase tracking-wide" data-id="element-220">
              Complemento exclusivo — No disponible después
            </span>
          </div>
          <div className="p-4" data-id="element-221">
            <div className="flex gap-4 items-start mb-3" data-id="element-222">
              <img src="https://cdn.magicpatterns.com/uploads/sy3aBZJfG15rR2iZzXPtdo/Order_Bump_2_Dopamina_Real_.png" alt="Dopamina Real" className="w-24 md:w-28 rounded-lg shadow-sm shrink-0 object-cover" data-id="element-223" />
              <h4 className="font-bold text-[#1e3a5f] text-sm md:text-base leading-snug" data-id="element-224">
                Expande las ideas del bono con 101 retos más — Desbloquea la
                creatividad de tus hijos{' '}
                <span className="text-red-600" data-id="element-225">(Solo $9.00)</span>
              </h4>
            </div>
            <p className="text-[#2d3748] text-xs md:text-sm leading-relaxed mb-3" data-id="element-226">
              Si te gustaron las 50 ideas del bono, este complemento te
              encantará.
              <br data-id="element-227" />
              Con <strong data-id="element-228">"DOPAMINA REAL"</strong>, recibirás{' '}
              <strong data-id="element-229">101 ideas y retos de autonomía</strong> organizados por
              edades, diseñados para que tus hijos desarrollen creatividad,
              iniciativa y confianza sin depender de pantallas.
              <br data-id="element-230" />
              Desde juegos sensoriales para los más pequeños hasta retos de
              creatividad y mini-proyectos para adolescentes.
              <br data-id="element-231" />
              Convierte el clásico <em data-id="element-232">"me aburro"</em> en momentos de
              aprendizaje, imaginación y diversión real.
            </p>
            <label className="flex items-start gap-3 cursor-pointer group p-3 rounded-lg border border-blue-200 bg-blue-50 hover:bg-blue-100 transition-colors" onClick={() => setBump2(!bump2)} data-id="element-233">
              <div className={`w-5 h-5 rounded border-2 flex items-center justify-center shrink-0 mt-0.5 transition-colors ${bump2 ? 'bg-blue-600 border-blue-600' : 'border-gray-300 bg-white'}`} data-id="element-234">
                {bump2 && <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-235">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-236" />
                  </svg>}
              </div>
              <span className="text-xs md:text-sm text-[#1e3a5f] font-semibold leading-snug" data-id="element-237">
                Sí, quiero las 101 ideas adicionales por solo{' '}
                <span className="text-red-600" data-id="element-238">$9.00 USD</span>
              </span>
            </label>
          </div>
        </div>

        {/* Desglose detallado */}
        <div className="mt-5 bg-white rounded-xl border border-gray-200 shadow-md overflow-hidden" data-id="element-239">
          <div className="bg-[#1e3a5f] px-4 py-3 text-center" data-id="element-240">
            <h3 className="text-white font-bold text-sm uppercase tracking-wide" data-id="element-241">
              📋 Resumen de tu pedido
            </h3>
          </div>
          <div className="p-4 space-y-3" data-id="element-242">
            {/* Item 1 */}
            <div className="flex justify-between items-center" data-id="element-243">
              <span className="text-sm text-gray-700" data-id="element-244">
                Pantallas Bajo Control
              </span>
              <span className="text-sm text-gray-400 line-through" data-id="element-245">$47.00</span>
            </div>
            {/* Item 2 */}
            <div className="flex justify-between items-center" data-id="element-246">
              <span className="text-sm text-gray-700" data-id="element-247">3 Bonos Exclusivos</span>
              <span className="text-sm text-gray-400 line-through" data-id="element-248">$36.00</span>
            </div>
            {/* Bump 1 */}
            {bump1 && <div className="flex justify-between items-center animate-fadeIn" data-id="element-249">
                <span className="text-sm text-green-700 font-medium" data-id="element-250">
                  ✅ Botón de Paz
                </span>
                <span className="text-sm text-green-700 font-semibold" data-id="element-251">
                  + $7.00
                </span>
              </div>}
            {/* Bump 2 */}
            {bump2 && <div className="flex justify-between items-center animate-fadeIn" data-id="element-252">
                <span className="text-sm text-blue-700 font-medium" data-id="element-253">
                  ✅ Dopamina Real
                </span>
                <span className="text-sm text-blue-700 font-semibold" data-id="element-254">
                  + $9.00
                </span>
              </div>}

            {/* Separador */}
            <div className="border-t border-gray-200 pt-3" data-id="element-255">
              <div className="flex justify-between items-center" data-id="element-256">
                <span className="text-sm text-gray-500" data-id="element-257">Valor total</span>
                <span className="text-sm text-gray-400 line-through" data-id="element-258">
                  ${(83 + (bump1 ? 7 : 0) + (bump2 ? 9 : 0)).toFixed(2)}
                </span>
              </div>
            </div>

            {/* Total a pagar */}
            <div className="border-t-2 border-[#dc4a3d] pt-3" data-id="element-259">
              <div className="flex justify-between items-center" data-id="element-260">
                <span className="text-lg font-bold text-[#dc4a3d]" data-id="element-261">
                  Hoy pagas solo
                </span>
                <span className="text-3xl font-extrabold text-[#dc4a3d]" data-id="element-262">
                  ${totalPrice.toFixed(2)}{' '}
                  <span className="text-base font-normal" data-id="element-263">USD</span>
                </span>
              </div>
            </div>

            {/* Botón de compra dinámico */}
            <div className="pt-4" data-id="element-264">
              <Button fullWidth size="lg" onClick={handleBuy} className="shadow-xl shadow-red-200 text-base" data-id="element-265">
                ¡COMPRAR AHORA — ${totalPrice.toFixed(2)} USD!
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}